<template>
  <li
    v-bind:class="{
      active: sidebarActiveButton === 'advancedconfig',
      disabled: boxConfig.advanced.view_mode === 'click'
    }"
    @click="handleClick()"
    title="Config.">
    <i class="icon-kp-config"></i>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    sidebarActiveButton: 'sidebarActiveButton',
    boxConfig: 'boxConfig',
  }),
  methods: {
    ...mapActions([
      'sidebarChangePanel',
      'sidebarChangeActiveButton',
      'canvasChangeView',
    ]),
    handleClick() {
      if (this.boxConfig.advanced.view_mode === 'click') {
        return false;
      }

      this.sidebarChangePanel('exibitionmode');
      this.sidebarChangeActiveButton('advancedconfig');
      this.canvasChangeView('preview');

      return true;
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** AdvancedConfig.vue?d004697e
 **/